import { setBlueprintTwMerge } from "@made-people/blueprint";
import { extendTailwindMerge } from "tailwind-merge";
import { tailwindTheme } from "./tailwind-theme";

setBlueprintTwMerge(
  extendTailwindMerge({
    extend: {
      theme: {
        color: tailwindTheme?.colors
          ? Object.keys({
              ...tailwindTheme?.colors,
            })
          : [],
      },
      classGroups: {
        "font-size": tailwindTheme?.fontSize
          ? Object.keys({
              ...tailwindTheme?.fontSize,
            }).map((key) => `text-${key}`)
          : [],
        "bg-color": tailwindTheme?.colors
          ? Object.keys({
              ...tailwindTheme?.colors,
            }).map((key) => `bg-${key}`)
          : [],

        "text-color": tailwindTheme?.colors
          ? Object.keys({
              ...tailwindTheme?.colors,
            }).map((key) => `text-${key}`)
          : [],
      },
      conflictingClassGroups: {
        "font-size": ["font-weight", "tracking"],
        "font-weight": ["font-family"],
      },
    },
  }),
);
